<template>
  <AddPosts update />
</template>
<script>
import appConfig from '@/app.config'
import AddPosts from '../../../components/skillup/posts/AddPosts.vue'
export default {
  page: {
    title: 'ویرایش پست',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-edit-posts',
  components: {
    AddPosts,
  },
}
</script>
